<template>
  <div class="preenchimento-form-tarefa">
    <div class="container is-flex is-flex-direction-column is-align-items-center">
      <template
        v-for="(campo, index) in formData.camposPersonalizados"
        :key="campo.id || campo.uuid || index"
      >
        <div class="box-campo is-relative" tabindex="-1">
          <TrfCampoPreenchivel
            :isPreenchimento="pIsPreenchimento"
            :pCampo="campo"
            :pIsConferencia="pIsConferencia"
            :isForcedDirty="isForcedDirty"
            @update:value="($event) => setCampoAlterado($event, campo, index)"
            @set:validacao="($event) => setValidacao($event)"
          ></TrfCampoPreenchivel>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import FormularioTarefa from '../../../../model/formulario-tarefa.model.js';

export default {
  name: 'TrfPreenchimentoFormTarefa',
  emits: ['update:form-data'],
  components: {
    TrfCampoPreenchivel: defineAsyncComponent(() => import('../../../../components/VisualizarForm/components/CampoPreenchivel.vue'))
  },
  props: {
    pFormData: {
      type: Object,
      default: () => new FormularioTarefa()
    },
    pIsPreenchimento: {
      type: Boolean,
      default: true
    },
    pIsConferencia: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: this.pFormData,
      isForcedDirty: false,
      formValidacoes: {}
    };
  },
  computed: {
    isFormValido() {
      let status = true;
      for (const validacao in this.formValidacoes) {
        if (!this.formValidacoes[validacao]) {
          status = false;
          break;
        }
      }
      return status;
    }
  },
  watch: {
    pFormData: {
      immediate: true,
      handler(novo) {
        this.formData = novo;
      },
      deep: true
    }
  },
  methods: {
    setValidacao(validacao) {
      const guid = `g${validacao.campo.uuid}`;
      this.formValidacoes[guid] = validacao.isValido;
    },
    async doValidar() {
      this.isForcedDirty = true;
      await this.$nextTick();
      return this.isFormValido;
    },
    setCampoAlterado(evento, campo, index) {
      if (!evento) return;
      const campoAlterado = { ...campo, ...evento };
      this.formData.camposPersonalizados[index] = campoAlterado;
      this.$emit('update:form-data', this.formData);
    }
  }
};
</script>

<style lang="scss" scoped>
.preenchimento-form-tarefa {
  width: 100%;
}
.container {
  box-sizing: border-box;
  padding-right: 4rem;
}
.box-campo {
  border-top: 0.75rem solid var(--primaryColor, #a82339);
  border-left: 1rem solid var(--primaryColor, #a82339);
  border-radius: 8px;
  padding: 2em;
  width: 100%;
  max-width: 744px;
  box-sizing: border-box;
  box-shadow: 2px 2px 2px #70757a66;
  transition: border 0.35s ease 0s;
  margin-bottom: 2.25rem;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}
</style>

<style lang="scss">
.preenchimento-form-tarefa {
  .box-campo {
    box-shadow: 2px 2px 2px rgba(169, 68, 66, 0.4) !important;
  }
  .allow-markup-error {
    label:not(.checkbox):not(.radio),
    .titulo-campo-preenchivel,
    .titulo-campo-preenchivel strong,
    .titulo-campo-preenchivel span {
      color: #a94442 !important;
    }
    .multiselect,
    input[type='text'],
    input[type='number'],
    select,
    textarea,
    input[type='tel'],
    input[type='email'],
    input.input {
      border: 1px solid #a94442 !important;
    }
    .error-message {
      font-size: 12px !important;
      color: #a94442 !important;
    }
  }
}
</style>
